<template>
  <v-container class="pa-md-5" fluid>
    <v-row>
      <v-col cols="12">
        <h2 class="secondary--text">Captaciones</h2>
        <v-divider class="mb-8 mt-2"></v-divider>
        <ContactList />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ContactList from "@/components/Contact/ContactList";

export default {
  name: "Contacts",
  components: {
    ContactList,
  },
};
</script>
